import { useState } from "react";
import { toast } from "sonner";
import { X, Plus } from "lucide-react";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { UserSelect } from "./LegalPickers";
import { errMsg } from "./legalUtils";

export const LegalSettings = ({ meta, onClose, onSaved }) => {
  const [rep, setRep] = useState(meta.legal_rep_id || "");
  const [cats, setCats] = useState(meta.categories);
  const [nc, setNc] = useState("");
  const save = async () => {
    try { await api.legalSettings({ legal_rep_id: rep || null, categories: cats }); toast.success("تم الحفظ"); onSaved(); onClose(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent dir="rtl" className="max-w-md" data-testid="legal-settings-dialog">
        <DialogHeader className="text-right"><DialogTitle className="font-heading">إعدادات الشؤون القانونية</DialogTitle>
          <DialogDescription>الممثل القانوني يرى كل الحالات ويستطيع إعادة فتحها. لمنح الوصول لغيره: إدارة المستخدمين ← الصلاحيات ← الشؤون القانونية (أرشيف القضايا = وصول كامل).</DialogDescription></DialogHeader>
        <label className="text-xs font-semibold text-slate-500">الممثل القانوني</label>
        <UserSelect users={meta.users} value={rep} onChange={setRep} testId="legal-rep-select" />
        <label className="mt-2 text-xs font-semibold text-slate-500">تصنيفات الأرشيف</label>
        <div className="flex flex-wrap gap-1.5">{cats.map((c) => <span key={c} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-1 text-xs">{c}<button onClick={() => setCats(cats.filter((x) => x !== c))}><X className="h-3 w-3" /></button></span>)}</div>
        <div className="flex gap-2"><Input value={nc} onChange={(e) => setNc(e.target.value)} placeholder="تصنيف جديد" data-testid="legal-new-cat" />
          <Button variant="outline" onClick={() => { if (nc.trim() && !cats.includes(nc.trim())) setCats([...cats, nc.trim()]); setNc(""); }}><Plus className="h-4 w-4" /></Button></div>
        <Button onClick={save} className="bg-[#0f1f3d]" data-testid="legal-settings-save">حفظ</Button>
      </DialogContent>
    </Dialog>
  );
};
